import {Component, Input, OnInit} from '@angular/core';
import {TaskService} from '../../../../services/task.service';
import {NzMessageService} from 'ng-zorro-antd/message';
import {TablePulseAbstractComponent} from '../../table-pulse-abstract/table-pulse-abstract.component';

@Component({
  selector: 'app-table-pulse-time-interval',
  templateUrl: './table-pulse-time-interval.component.html',
  styleUrls: ['../../../../views/new-table/new-table.component.css']
})
export class TablePulseTimeIntervalComponent extends TablePulseAbstractComponent implements OnInit {
  constructor(
    private taskHttpService: TaskService,
    private nzMessageService: NzMessageService
  ) {
    super(nzMessageService, taskHttpService);
  }

  ngOnInit(): void {
  }

}
